<div class="search-wrapper mb-1">
  <div class="input-group input-group-sm">
    <input type="text" class="form-control editable" id="searchField" autocomplete="off" [style.caretColor]="accentColor"
      [placeholder]="placeholderText" [(ngModel)]="searchText" #dashModuleSearch matTooltip="Press Enter to search, Esc to clear"
      (keyup.escape)="(dashModuleSearch.value.length) ? clearEvent() : null" (keyup.arrowdown)="moveSelectionDown()"      
      (keyup.arrowup)="moveSelectionUp()" (keyup)="processKeyEvent($event)"  aria-label="Search"
      aria-describedby="basic-addon2">
    <button *ngIf="allDataDropdown" type="button" class="btn btn-outline-primary" title="Show List" name="basic-addon3" (click)="openDropdown()" (keyup.arrowup)="moveSelectionUp()" (keyup.arrowdown)="moveSelectionDown()" (keyup.enter)="processKeyEvent($event)">
      <i class="fal fa-lg" [ngClass]="{'fa-chevron-square-down': !hadText, 'fa-chevron-square-up': hadText}"></i>
    </button>
    <button *ngIf="!selectionMode" class="btn btn-primary" name="basic-addon2" [disabled]="dashModuleSearch.value.length < 2" type="button" id="btnLibSearch" (click)="executeBroadSearch()">
      <i class="fal fa-lg fa-search" style="color: white;"></i>
    </button>
    <button class="btn" type="button" style="background: var(--RAred); color: white;"
      [disabled]="loading || configLocked"
      [ngClass]="{'btn-dark': !configMode, 'btn-outline-dark active': configMode}"
      name="basic-addon1" [matTooltip]="configLocked ? 'Search options are disabled here' : 'Toggle search options'" 
      (click)="configureSearch()"
      [popover]="defaultConfiguration" [outsideClick]="true"
      [placement]="'bottom'" [popoverTitle]="'Refine your search fields'">
        <i [class]="'fal fa-lg ps-1 pe-1 ' + configIcon" [ngClass]="{'': !loading, 'fa-spinner fa-spin': loading}"></i>    
      </button>
  </div>
  <!--<div *ngIf="dropDown">
    <ng-container *ngTemplateOutlet="defaultDataDropdown"></ng-container>
  </div>-->
  <!-- <div *ngIf="configMode">
    <ng-container *ngTemplateOutlet="defaultConfiguration"></ng-container>
  </div> -->
</div>

<ng-template #defaultConfiguration>
  <div class="popoverConfig" [style.z-index]="zIndex">

    <div style="font-size: 1rem;">
      <div class="row" *ngFor="let f of modularSearchFields">
        <div class="col">
          <label class="fieldLabel" [ngClass]="{'text-muted': !f.enabled}" [ngStyle]="{'font-weight': (f.enabled ? 'bold': '100')}" [for]="'sc' + f.displayName">
            {{ f.displayName }}
          </label>
        </div>
        <div class="col">
          <label class="switch">
            <input [id]="'sc' + f.displayName" type="checkbox" (change)="fieldsChosenChanged(f)"
             [(ngModel)]="f.enabled">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultDataDropdown>
  <div *ngIf="hadText">
    <div *ngIf="dataToShow.length > 0 && dataToShow[0].totalMatches > 0 && !loading; else noResults" class="search-dropdown">
      <div class="dropdown-intro">
        <span>
          We found <strong><em>{{ dataToShow[0].totalMatches }}</em></strong> suggestions.
          Press <i class="fal fa-search fa-sm" style="font-weight: 600;"></i> to view all results or choose a search suggestion below.
        </span>
      </div>
      <div style="padding: 0 .5em; color: var(--RAred);">
          <strong>Search Suggestions</strong>
      </div>
      <ul>
        <div *ngFor="let match of dataToShow[0].matches">
          <div *ngFor="let h of match.hits | keyvalue: none; let i = index">
            <div *ngIf="(h.value | json).length" class="search-match-encompass" [ngStyle]="{'border-top': i === 0 ? 'none': '1px solid #999'}">
              <h5 class="dropdown-header search-match-property">
                {{ translatePropNameToDisplay(h.key) }} <small class="text-muted">({{ (h.value | json).length + ((h.value | json).length > 1 ? ' matches' : ' match') }})</small>
              </h5>
              <li class="ms-3 search-match" *ngFor="let hh of h.value; let j = index" [ngClass]="{'highlight': finder[keySelectionIndex]?.hitText == hh && finder[keySelectionIndex].property == (h.key | json)}" [ngStyle]="{'border-bottom': (h.key | json) == 'keyword' ? 'none' : 'inherit'}" (click)="outputSelectedMatch(match.tableName, h.key, hh)">
                <span class="badge badge-pill badge-dark keyword mb-1" style="font-size: 1rem;" *ngIf="(h.key | json) == 'keyword'; else suggestionWord">{{ hh }}</span>
                <ng-template #suggestionWord>
                  <div class="search-match" [innerHtml]="hh | embolden : searchText : 22"></div>
                </ng-template>
              </li>
            </div>
          </div>
        </div>
      </ul>
    </div>
    <ng-template #noResults>
      <div class="search-dropdown no-results dropdown-intro">
        <span *ngIf="fieldsEnabledCount < 1"><i class="fal fa-exclamation-triangle"></i> You have disabled all search fields. Press the <i [class]="'fal fa-sm fa-fw ' + configIcon"></i> button to change this.</span>
        <span *ngIf="fieldsEnabledCount > 0 && !loading"><i class="fal fa-minus-circle"></i> We didn't find any suggestions for that. <br>Try using the filter system.</span>
      </div>
    </ng-template>
  </div>
</ng-template>
